import React from "react";
import { Navigate } from "react-router-dom";

export function AdminProtectedRoute({ children }) {
  const token = localStorage.getItem("adminToken");
  if (!token) {
    return <Navigate to="/admin/login" replace />;
  }
  return children;
}
